module.exports = __webpack_public_path__ + "img/i-2.002818e8.svg";